import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { appointmentFormEndpoints } from '@/lib/api/endpoints';
import { formSubmissionKeys } from '@/lib/queryKeys';
import type { FormSubmission } from '@/types/appointmentForm';

/** Load signed evidence only when the submission is opened. */
export function useFormSubmission(id: string) {
  return useApiQuery<FormSubmission>({
    queryKey: formSubmissionKeys.detail(id),
    queryFn: () =>
      apiGet<FormSubmission>(operationsClient, appointmentFormEndpoints.submission(id)),
    // Opening an old cached submission should renew its signed photo links.
    refetchOnMount: 'always',
    showErrorToast: false,
  });
}
